export function sendFilter(target=null) {
  $("#index-loader").show()
      
  setTimeout(()=>{  
    let searchFormEl = document.querySelector('.search')
    let searchParams = new URLSearchParams(window.location.search)
    let formParams = {}
    
    $.each($(searchFormEl).serializeArray(), function(_, kv) {
      formParams[kv.name] = kv.value
    })

    for (const [k, v] of Object.entries(formParams)) {
      let _key = k.replace('search[', '').replace(']', '')
      if (k == 'search[m_is_cur]' && target && target.attr('id') != 'search_m_is_cur') {
        if (formParams['search[tournament]']) {
          searchParams.set(_key, 'all') 
        } else {
          searchParams.delete(_key)
        }
      } else if (v && v != 0) {
        searchParams.set(_key, v.replace(/\s+/g, ' ').trim())
      } else {
        searchParams.delete(_key)
      }
    }

    searchParams.delete('page')
    searchParams.delete('button')

    if (searchParams.toString()) {
      Turbolinks.visit(window.location.pathname + '?' + searchParams.toString())
    } else {
      Turbolinks.visit(window.location.pathname)
    }
    
  }, 200)
}
  